<template>
  <div>
    <van-divider :style="{ borderColor: '#888888', padding: '0 120px', color: '#1baeae' }">热卖推荐</van-divider>
    <div class="tpl">
      <div
        class="item"
        v-for="item in list"
        :key="item.id"
        v-on:click="$router.push('/' + module + '/detail/'+item.id)"
      >
        <div>
          <van-image width="100%" radius="10px" height="150" fit="cover" :src="GLOBAL.IMG + item.thumbnail" />
        </div>
        <div class="t">{{item.post_title}}</div>
        <div class="p">¥{{item.price}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Divider } from "vant";

Vue.use(Divider);
export default {
  name: "tuiijan",
  props: ["list", "module"]
};
</script>
<style lang="scss" scoped>
.tpl {
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .item {
    background-color: #fff;
    padding: 3px 3px 10px 3px;
    width: 33.3%;
    .t {
      line-height: 25px;
      height: 50px;
      overflow: hidden;
      color: #222333;
    }
    .p {
      color: #1baeae;
    }
  }
}
</style>